import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import service from '../service';
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { workDistributionSummaryReportSchema } from '../workDistributionReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _ from 'lodash';
import Autocomplete from '@material-ui/lab/Autocomplete';

const screenCode = "WORKDISTRIBUTIONSUMMARYREPORT";

export function WorkDistributionSummaryReport(props) {

    const [groups, setGroups] = useState([]);
    const [jobCategories, setJobCategories] = useState([]);
    const [estates, setEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [employeeCodes, setEmployeeCodes] = useState([]);

    const [csvHeaders, setCsvHeaders] = useState([]);
    const [totalRow, setTotalRow] = useState([])

    const [workDistributiondetails, setWorkDistributionDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        estateTaskID: 0,
        taskID: 0,
        fromDate: "",
        toDate: ""
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        division: "0",
        employeeCode: "",
        fromDate: "",
        toDate: ""
    })

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [buttonHide, setButtonHide] = useState(true);

    const schema = Joi.object(workDistributionSummaryReportSchema).options({ allowUnknown: true });

    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown(),
            getAllJobCategoriesForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [workDistributiondetails.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),

        )
    }, [workDistributiondetails.estateID])

    useEffect(() => {
        trackPromise(getPermissions(),
            getAllAllJobCodesForDropdown()
        );
    }, []);


    useEffect(() => {
    }, [reportData]);

    function handleGroupChange(target) {
        validateInputs(target);

        setWorkDistributionDetails({
            ...workDistributiondetails,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",

        });
    }
    function handleEstateChange(target) {
        validateInputs(target);

        setWorkDistributionDetails({
            ...workDistributiondetails,
            estateID: target.value,
            divisionID: "0",

        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setWorkDistributionDetails({
            ...workDistributiondetails,
            divisionID: target.value,

        });
    }
    function handlejobCategoriesChange(target) {
        validateInputs(target);

        setWorkDistributionDetails({
            ...workDistributiondetails,
            estateTaskID: target.value,

        });
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setWorkDistributionDetails({
            ...workDistributiondetails,
            toDate: target.value
        })
    }
    function handleFromDateChange(target) {
        validateInputs(target);

        setWorkDistributionDetails({
            ...workDistributiondetails,
            fromDate: target.value,

        });
    }

    function handleSearchDropdownChange(data) {

        if (data === undefined || data === null) {
            setWorkDistributionDetails({
                ...workDistributiondetails,
                taskID: 0
            });
        }
        else {
            var nameV = "taskName";
            var valueV = data["taskID"];

            setWorkDistributionDetails({
                ...workDistributiondetails,
                taskID: valueV.toString()
            });
        }
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, workDistributionSummaryReportSchema);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWWORKDISTRIBUTIONSUMMARYREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');


        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();

        setWorkDistributionDetails({
            ...workDistributiondetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await service.getAlGroupsForDropdown();
        setGroups(result);
    }
    async function getAllJobCategoriesForDropdown() {
        const result = await service.getAllJobCategoriesForDropdown();
        setJobCategories(result);
    }

    async function getEstatesForDropdown() {
        const data = await service.getEstatesByGroupID(workDistributiondetails.groupID);
        setEstates(data);
    }

    async function getDivisionsForDropDown() {
        const data = await service.getDivisionByEstateID(workDistributiondetails.estateID);
        setDivisions(data);
    }

    async function getAllAllJobCodesForDropdown() {
        const result = await service.getAllAllJobCodesForDropdown();
        setEmployeeCodes(result);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {

        e.preventDefault();
        setIsTableHide(true);
        setButtonHide(true);
        const errorMessages = validate(schema, workDistributiondetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        getSelectedDropdownValuesForReport(workDistributiondetails);
        setIsTableHide(true);

        const results = await service.getWorkDistributionDetails(workDistributiondetails);

        var copyOfResult = _.cloneDeep(results)

        let result = [];
        let names = [];
        var csvHeaders = [
            { label: "EMP No", value: "taskName" },
        ];

        copyOfResult.forEach(x => {

            var createdDate = x.createdDate.split("T")[0];

            var duplicate = result.find(y => y.taskName === x.taskName);

            var duplicateName = names.find(y => y === createdDate);

            if (duplicateName) {
                duplicateName = createdDate;
            }
            else {
                names.push(createdDate);
            }

            if (duplicate) {
                duplicate[createdDate + ' T'] = parseFloat(x.empcount);
                duplicate.taskName = x.taskName;

            }
            else {
                result.push({
                    [createdDate + ' T']: parseFloat(x.empcount),
                    taskName: x.taskName,
                    ttotal: parseFloat(x.empcount),

                });
            }

        });
        for (let index = 0; index < names.length; index++) {
            csvHeaders.push({ label: names[index], value: names[index] + ' T' });
        }

        csvHeaders.push({ label: 'Total', value: 'ttotal' });

        var resultOne = await calcCSVRows(result)

        var totOfColss = _.cloneDeep(resultOne)

        let totalResult = [];

        names.forEach(x => {
            let ttotal = 0.0;
            let tAllTotal = 0.0;
            totOfColss.forEach(y => {
                if (y[x + ' T']) {
                    ttotal = ttotal + y[x + ' T']
                }
                if (y['ttotal']) {
                    tAllTotal = tAllTotal + y['ttotal']
                }
            });
            totalResult.push({
                [x + ' T']: ttotal
            })
            totalResult.push({
                ['ttotal']: tAllTotal
            })
        });

        totalResult.push({ "taskName": "Total" })

        let finalObj = {};
        for (let i = 0; i < totalResult.length; i++) {
            Object.assign(finalObj, totalResult[i]);
        }

        setTotalRow(finalObj);
        setCsvData(resultOne);
        setCsvHeaders(csvHeaders);

    }

    async function calcCSVRows(result) {
        result.forEach(x => {
            var tTotal = 0.0;
            Object.entries(x).map(([key, value]) => {

                if (key.match(/^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])\s+(\bT\b)$/)) {
                    tTotal = tTotal + parseFloat(value);
                }
            });
            x.ttotal = tTotal;
        })
        return result;
    }

    function createFile() {
        var settings = {
            sheetName: 'Plucking Attendance Report',
            fileName: 'PluckingAttendanceReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(csvData)

        var copyOfTotalRow = _.cloneDeep(totalRow)

        var newRow1 = {
            taskName: "Job Code : " + [workDistributiondetails.taskID == "" ? "ALL" : workDistributiondetails.taskID],
        }
        var newRow2 = {
            taskName: "Estate : " + estates[workDistributiondetails.estateID],
        }
        var newRow3 = {
            taskName: "Group : " + groups[workDistributiondetails.groupID],
        }
        var newRow4 = {
            taskName: "Division : " + [selectedSearchValues.division],
        }
        var newRow5 = {
            taskName: "From Date : " + [workDistributiondetails.fromDate],
        }
        var newRow6 = {
            taskName: "To Date : " + [workDistributiondetails.toDate],
        }
        var newRow7 = {
            taskName: "Job Category : " + [workDistributiondetails.estateTaskID == 0 ? "ALL" : workDistributiondetails.estateTaskID],
        }

        copyOfCsv.push(copyOfTotalRow, {}, {}, newRow3, newRow2, newRow4, newRow5, newRow6, newRow1, newRow7)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            employeeCode: employeeCodes[searchForm.employeeCode],
            fromDate: searchForm.searchDate,
            toDate: searchForm.searchDate,
        })

    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Work Distribution Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={workDistributiondetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={workDistributiondetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={workDistributiondetails.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Division--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="fromDate"
                                            name="fromDate"
                                            type="date"
                                            onChange={(e) => handleFromDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["fromDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["fromDate"]}</FormHelperText>)}
                                    </div>

                                </div>
                                <div className="form-group row">
                                    <div className="col-md-3">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="toDate"
                                            name="toDate"
                                            type="date"
                                            onChange={(e) => handleToDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["toDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["toDate"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-3">
                                        <InputLabel shrink id="">Job Category</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateTaskID"
                                            id="estateTaskID"
                                            name="estateTaskID"
                                            value={workDistributiondetails.estateTaskID}
                                            onChange={(e) => handlejobCategoriesChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Job Category--</MenuItem>
                                            {generateDropDownMenu(jobCategories)}
                                        </Select>
                                        {errors["estateTaskID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateTaskID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md-3">
                                        <InputLabel shrink id="taskName">Job Code</InputLabel>
                                        <Autocomplete
                                            fullWidth
                                            id="taskName"
                                            options={employeeCodes}
                                            getOptionLabel={(option) => option.taskName}
                                            size="small"
                                            onChange={(event, value) => handleSearchDropdownChange(value)}
                                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                                        />
                                        {errors["taskName"] && <FormHelperText error>{errors["taskName"]}</FormHelperText>}
                                    </div>


                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />
                                </div>
                            </form>
                        </div>
                        {csvData.length != 0 ?
                            <div className="card-footer">
                                <input
                                    type="button"
                                    className="btn btn-primary"
                                    value="Excel"
                                    onClick={createFile}
                                />
                            </div>
                            : null}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
